<template>
<div class="free-collection-box" v-show="isQrCode">
    <div class="free-collection-code" >
            <div :class=" type=='payment' || type == 'formal'?'payment':'dia-colse' " @click="closeDia">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ba633cb8=""><path fill="currentColor" d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"></path></svg>
            </div>
            <!-- //ai课 -->
            <img v-if="type == 'AIClass'" src="../assets/Learning/attendance_authority.png" alt="">
            <div class="code-img" v-if="type == 'AIClass'">
                <img  src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/guanwangdownload.png" alt="" srcset="">
            </div>
            <!-- 正式课 -->
            <!-- <img v-if="type == 'formal'" src="../assets/Learning/attendance_authority_1.png" alt=""> -->
            <div class="video-code" v-if="type == 'formal'">
                <div>
                    <img src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/WeChat-icon.png" alt="" srcset="">
                    <p>
                        微信扫码付款
                    </p>
                </div>
                <p>
                    <QrcodeVue v-if="payData.code_url" :size='200' :value="payData.code_url" />
                </p>
                <span @click="purchaseSucceeded" v-if="payData.code_url">购买成功</span>
            </div>
            <!-- 影音付费 -->
            <!-- <img v-if="type == 'video'" src="../assets/Learning/attendance_authority_2.png" alt=""> -->
            <div class="video-code" v-if="type == 'payment'">
                <div>
                    <img src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/WeChat-icon.png" alt="" srcset="">
                    <p>
                        微信扫码付款
                    </p>
                </div>
                <p>
                    <QrcodeVue v-if="payData.code_url" :size='200' :value="payData.code_url" />
                </p>
                <span @click="purchaseSucceeded" v-if="payData.code_url">购买成功</span>
                
            </div>
                <!-- 下载app -->
            <img v-if="type == 'DownloadApp'" src="../assets/Learning/attendance_authority_3.png" alt="">
            <div class="code-img" v-if="type == 'DownloadApp'">
                <img src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/guanwangdownload.png" alt="" srcset="">
            </div>
        </div>
</div>
         
</template>
<script>
import { defineComponent, reactive } from 'vue'
import QrcodeVue from 'qrcode.vue'
export default defineComponent({
    props:{
        isQrCode:Boolean,
        type:String,
        payData:{
            type:Object,
            default:()=>{
                return {}
            }
        }
    },
    setup(props,ctx) {
        const state = reactive({
            isQrCode:false,
            typePage:""
        })
        const closeDia = ()=>{
            // state.isQrCode = false
            ctx.emit('closeDia')
        }
        const purchaseSucceeded = ()=>{
            location.reload();
        }
        return{
            state,
            closeDia,
            purchaseSucceeded
        }
    },
    components:{
        QrcodeVue
    }
})
</script>

<style lang="less" scoped>
.free-collection-box{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
}
.free-collection-code{
        position: absolute;
        z-index: 1;
        top: 60%;
        left: 50%;
        margin-left: -175px;
        margin-top: -325px;
        width: 350px;
        .dia-colse{
            width: 30px;
            height: 30px;
            color: #DEBB88;
            position: absolute;
            bottom: -50px;
            left: 50%;
            margin-left: -15px;
            cursor: pointer;
            font-size: 0;
            border: 1px solid #DEBB88;
            border-radius: 50%;
        }
        .payment{
            width: 30px;
            height: 30px;
            color: #C3272B;
            position: absolute;
            top: 10px;
            right: 0;
            cursor: pointer;
            font-size: 0;
            // border: 1px solid #DEBB88;
            border-radius: 50%;
        }
        .code-img{
            width: 200px;
            height: 200px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -100px;
            margin-top: -50px;
            img{
                width: 100%;
            }
        }
        .video-code{
            width: 360px;
            height: 400px;
            background: #fff;
            border-radius: 10px;
            padding: 40px 60px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 33px;
                height: 29px;
                margin-right: 10px;
            }
            >p{
                margin-top: 20px;
            }
            >div{
                display: flex;
                align-items: center;
                justify-content: center;
                p{
                    font-size:30px;
                    color: #000;
                }
            }
            >span{
                padding: 5px 26px;
                background: #C3272B;
                font-size: 24px;
                color: #fff;
                margin-top: 20px;
                cursor: pointer;
            }
        }
    }
</style>